export enum RiskScope {
  Global = 'global',
  Hybrid = 'hybrid',
  Local = 'local',
}
